<template>
  <div>
    <div class="text-center mt-4" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="table-card mt-4" :loading="tableLoading">
            <v-card-title>
              <span class="accent--text">Слушатели</span>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="tableSearch"
                class="mt-0 pt-0 table-search"
                append-icon="mdi-magnify"
                label="Поиск"
                single-line
                hide-details
                clearable
              />
            </v-card-title>

            <v-data-table
              ref="byListenersTable"
              class="base-table elevation-0"
              loading-text="Загрузка..."
              fixed-header
              hide-default-footer
              hide-default-header
              :headers="headers"
              :items="listeners"
              :search="tableSearch"
              :items-per-page="-1"
            >
              <template #item.fullName="{ item }">
                <span class="link-wrapper">
                  <span class="link" @click="openDialog(item)">{{ item.fullName || '-' }}</span>
                </span>
              </template>

              <template slot="no-data">
                <div class="py-3">Нет слушателей на данном цикле</div>
              </template>

              <template slot="no-results">
                <div class="py-3">Ничего не найдено</div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <ListenerDialog
        :dialog="dialog"
        :selectedItem="selectedItem"
        @dataLoaded="tableLoading = false"
        @closeDialog="closeDialog"
      />
    </div>
  </div>
</template>

<script>
import { fileDpoCardApi } from '@/api'
import { mapGetters } from 'vuex'
import ListenerDialog from '@/components/cycles/cycle/accounting/dialogs/Listener'

export default {
  name: 'AccountingByListeners',

  props: {
    infoBlockHeight: Number
  },

  components: {
    ListenerDialog
  },

  async created() {
    await this.getAccountingListeners()
    this.dataLoaded = true
    this.setTableHeight()
  },

  mounted() {
    window.addEventListener("resize", this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener("resize", this.setTableHeight)
  },

  data: () => ({
    dataLoaded: false,
    tableLoading: false,
    tableSearch: null,
    headers: [
      { value: 'fullName', sortable: false, align: 'left' }
    ],
    selectedItem: null,
    dialog: false,
    listeners: []
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight']),
    ...mapGetters('cycle', ['cycleId', 'isCycleComplete'])
  },

  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        if (this.$refs?.byListenersTable) {
          const otherElements = 365 + this.infoBlockHeight + this.techMessageHeight
          this.$refs.byListenersTable.$el.style.maxHeight = window.innerHeight - otherElements + 'px'
        }
      })
    },

    async getAccountingListeners() {
      try {
        this.listeners = await fileDpoCardApi.getAccountingListeners(this.cycleId)
      } catch (e) {
        console.log(e.status)
      }
    },

    openDialog(item) {
      this.tableLoading = true
      this.selectedItem = item
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
    },
  },

  watch: {
    infoBlockHeight() {
      this.setTableHeight()
    }
  }
}
</script>